import { graphqlOperation, API } from 'aws-amplify';
import * as mutations from '../../graphql/mutations';

export const updateUser = async (id, status) => {
    const update = {
        id,
        status,
    };
    try {
        await API.graphql(
            graphqlOperation(mutations.updateUser, { input: update }),
        );
        return true;
    } catch (e) {
        console.log('Update Status Error: ' + JSON.stringify(e));
        return false;
    }
};

export const updateUserRole = async (id, role) => {
    const update = { id, role };
    try {
        await API.graphql(
            graphqlOperation(mutations.updateUser, { input: update }),
        );
        return true;
    } catch (e) {
        console.log('Update Status Error: ' + JSON.stringify(e));
        return false;
    }
};
